<template>
  <span>{{prettyNumber}}</span>
  <input :value="number" type="hidden">
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Money",
  methods:{
    substr_replace(str, replace, start, length)
    {
      if (start < 0)
      {
        // start position in str
        start = start + str.length
      }
      length = length !== undefined ? length : str.length;
      if (length < 0)
      {
        length = length + str.length - start
      }

      return [
        str.slice(0, start),
        replace.substr(0, length),
        replace.slice(length),
        str.slice(start + length)
      ].join('')
    },
    money(number)
    {
      if (!number)
        return number;
      number = number.toString();
      let n=number.length;

      let k=1;
      for(let j=n-1;j>=0;j--)
      {
        if(k%3===0 && j!==0)
          number = this.substr_replace(number, ',', j, 0);
        k++;
      }
      return number;
    },
    render:function ()
    {
      if (this.printNumber!==null)
      {
        this.prettyNumber = this.money(this.printNumber)
      }
    },
    set(num)
    {
      this.printNumber = num
      this.render();
    }
  },
  data:function ()
  {
    return {
      printNumber:'',
      prettyNumber:''
    }
  },
  watch:{
    number:function ()
    {
      this.printNumber = this.number
      this.render();
    }
  },
  mounted()
  {
    this.printNumber = this.number
    this.render();
  },
  props:['number']
}
</script>

<style scoped>

</style>